<template>
    <div>
        <v-container fluid class="px-0 search-doctor-banner pb-0 d-flex justify-center align-center" id="parent_container">
            <v-container fluid class="pb-0" :class="{'pl-12': $vuetify.breakpoint.mdAndUp}">
                <v-row>
                    <v-col cols="12" sm="12" md="12">
                        <div class="darkergray--text playfair-display mb-2 weight-semibold text-center" :class="$vuetify.breakpoint.mdAndUp ? 'font-32' : 'font-16'">
                            {{ stepDetails[step].title }} <span
                                v-if="step === 2 && userInfo"></span>
                        </div>
                        <div class="darkergray--text playfair-display mb-2 weight-semibold text-center" :class="$vuetify.breakpoint.mdAndUp ? 'font-32' : 'font-16'">
                            {{ stepDetails[step].description }}
                        </div>
                    </v-col>
                </v-row>
            </v-container>
        </v-container>
        <v-container>

            <v-row>
            <v-col cols="12" sm="12" md="7" offset-md="1" v-if="step === 0">
                    <v-alert                    
                        
                        border="left"
                        close-text="Close Alert"
                        color="blueBg"
                        class="py-2"
                        dark                    
                    >
                    <v-row align="center">
                        <v-col class="darkergray--text">
                            Your timezone is in <b>{{ moment().tz($store.getters.timezone).format('z') }}</b>.
                        </v-col>                        
                    </v-row>
                                            
            </v-alert>
            </v-col>
            
                <!--            Time Slot-->
                <v-col cols="12" sm="12" md="7" offset-md="1" v-if="step === 0" class="time-slots">
                    <v-row>
                        <v-col cols="12" class="pt-0">
                            <v-card tile>
                                <!--                                <v-autocomplete :items="bookingDates.months" v-model="bookingMonth" solo flat-->
                                <!--                                                hide-details style="width: 250px"></v-autocomplete>-->
                                <!--                                <v-btn-toggle-->
                                <!--                                        v-model="bookingDate"-->
                                <!--                                        mandatory-->
                                <!--                                        style="width: 100%"-->
                                <!--                                >-->
                                <!--                                    <v-row no-gutters>-->
                                <!--                                        <v-col>-->
                                <!--                                            <v-btn text width="100%" tile style="border: 1px solid #ccc"-->
                                <!--                                                   @click="makeBookingDates('prev')">-->
                                <!--                                                <v-icon>mdi-chevron-left</v-icon>-->
                                <!--                                            </v-btn>-->
                                <!--                                        </v-col>-->
                                <!--                                        <v-col v-for="day in bookingDates.dates" :key="day">-->
                                <!--                                            <v-btn text :value="day" @click="getSchedule(day)" width="100%" tile-->
                                <!--                                                   style="border: 1px solid #ccc">-->
                                <!--                                                {{ moment(day).format('ddd') }} <br>-->
                                <!--                                                {{ moment(day).format('DD') }}-->
                                <!--                                            </v-btn>-->
                                <!--                                        </v-col>-->
                                <!--                                        <v-col>-->
                                <!--                                            <v-btn text width="100%" tile style="border: 1px solid #ccc"-->
                                <!--                                                   @click="makeBookingDates('next')">-->
                                <!--                                                <v-icon>mdi-chevron-right</v-icon>-->
                                <!--                                            </v-btn>-->
                                <!--                                        </v-col>-->
                                <!--                                    </v-row>-->

                                <!--                                </v-btn-toggle>-->
                                <v-card-text>
                                    <date-picker :default_date="$route.query.date" v-model="bookingDate"></date-picker>
                                </v-card-text>
                            </v-card>
                        </v-col>
                        
                        <v-col cols="12">
                            <v-row v-if="!gettingSlots">
                                <v-col cols="12" v-for="schedule in schedulesList" :key="schedule.start_time">
                                    <div class="grey--text">
                                        {{ moment(schedule.start_time).format('hh:mm A') }} to
                                        {{moment(schedule.end_time).format('hh:mm A') }}
                                    </div>
                                    <div style="margin-left: -8px" v-if="schedule.slots.length">
                                        <v-chip v-model="selectedSlot" class="ma-2 text-center" 
                                                label v-for="slot in schedule.slots"
                                                :key="slot.start_time"
                                                :disabled="!slot.is_available"
                                                @click="selectSlot(slot)"
                                                style="display:inline-flex;justify-content:center"
                                                :class="{'accent': slot.is_selected}">

                                                {{ moment(slot.start_time).format('hh:mm A') }}
                                            
                                        </v-chip>
                                    </div>

                                    <div v-if="!schedule.slots.length">
                                        <span>No slots available.</span>
                                    </div>
                                </v-col>
                            </v-row>
                            <v-row v-else>
                                <v-col cols="12" class="text-center">
                                    <br>
                                    <v-progress-circular
                                            size="50"
                                            color="primary"
                                            indeterminate
                                    ></v-progress-circular>
                                </v-col>
                            </v-row>
                        </v-col>                        
                        
                        <v-col cols="12" class="mt-2">
                            <v-btn @click="$router.go(-1)" text class="primary mr-2">
                                <v-icon>mdi-chevron-left</v-icon>
                                Back
                            </v-btn>
                            <v-btn text class="white--text" @click="nextStep"
                                   :class="{ 'accent' :  Object.keys(selectedSlot).length, 'grey' :  !Object.keys(selectedSlot).length}"
                                   :disabled="!Object.keys(selectedSlot).length">
                                Continue
                            </v-btn>
                            <!--                            <div v-if="!userInfo" class="mt-2">-->
                            <!--                                <span class="red&#45;&#45;text">Please-->
                            <!--                                <a href="javascript:void(0)" @click="loginDialog = true">Login</a> to continue.</span>-->
                            <!--                            </div>-->
                            <div v-if="!Object.keys(selectedSlot).length && userInfo" class="mt-2">
                                <span class="red--text">Please select a time slot to continue</span>
                            </div>                            
                        </v-col>
                    </v-row>
                </v-col>

                <!--                Additional Info-->
                <v-col cols="12" sm="12" md="8" v-if="step === 1" class="mt-10">
                    <v-row>
                        <v-col cols="12" class="pb-0 mb-0">
                            <v-row>
                                                             
                                <v-col cols="12">
                                    <v-form>
                                        
                                        <v-row no-gutters>
                                            <v-col cols="12" sm="12" md="8" class="symtoms_container">
                                            <div class="d-flex align-center">
                                                <v-autocomplete                           
                                                
                                                hide-details="auto"
                                                refs="symptoms_component"
                                                id="symptoms_component"
                                                class="symptoms_component pr-4"
                                                chips
                                                :items="symptomsList"
                                                v-model="selectedSymptoms"
                                                :search-input.sync="symptomSearch"
                                                :loading="symptomLoading"
                                                deletable-chips
                                                multiple
                                                outlined
                                                dense                   
                                                return-object                             
                                                label="Symptoms"
                                                item-text="name"
                                                item-value="id"                                                
                                                >
                                                <template v-slot:selection="data">
                                                    <v-chip                                                    
                                                    class="mt-2 mb-2 ml-1 accent"
                                                    close
                                                    color="red"
                                                    small
                                                    text-color="white"
                                                    @click="data.select"
                                                    @click:close="removeSymptoms(data.item)"
                                                    v-bind="data.attrs"
                                                    :input-value="data.selected"
                                                    >
                                                    {{ data.item.name }}
                                                    </v-chip>
                                                    
                                                    
                                                    
                                                </template>
                                                </v-autocomplete>
                                                <v-icon v-if="1==0" class="align-self-center pointer" id="remove_focus" >mdi-close</v-icon>
                                            </div>
                                                
                                            </v-col>
                                            
                                            <v-col cols="12" sm="12" md="8" class="mt-8">
                                                <v-textarea placeholder="Describe your problem" solo flat                                                            
                                                            outlined
                                                            v-model="problem"></v-textarea>                                                
                                            </v-col>                                            
                                        </v-row>
                                    </v-form>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="12" class="mt-0 pt-0">
                            <v-btn text class="primary white--text mr-2" @click="step--">
                                Previous
                            </v-btn>
                            <v-btn text
                                    :loading="isLoading"
                                   class="white--text accent"                                   
                                   @click="nextStep()"                                   
                                   >
                                   <template v-if="step===maxStep">Confirm Appointment</template>
                                   <template v-else>
                                       <span v-if="selectedSymptoms.length || problem.length">Next</span>
                                       <span v-else>Skip</span>                                       
                                    </template>                                                                                                      
                            </v-btn>
                        </v-col>
                        
                    </v-row>
                </v-col>
                <v-col cols="12" sm="12" md="8" v-if="step === 2">
                    <v-row>
                        <v-col cols="12" class="pb-0 mb-0">
                            <v-row>
                                <v-col cols="12">
                                    <h2>Payment Mode</h2>
                                </v-col>                                                                 
                                <v-col cols=12 md="5" v-if="this.bookingType === 'clinic'">                                    
                                    <v-card                                        
                                        max-width="512"    
                                        outlined
                                        @click="paymentMode = 'online'"
                                    >
                                        <v-list-item three-line style="min-height:88px !important;" class="pa-5">
                                            <v-row  class="ma-0 pa-0">
                                                
                                                <v-col cols=12 class="pa-0 ">
                                                    <v-row class="ma-0 pa-0">
                                                        <v-col cols=8 class="pa-0">
                                                            <v-list-item-avatar
                                                                tile
                                                                size="104"
                                                                style="margin:auto; padding:16px"
                                                                color="grey lighten-4"
                                                            >
                                                                <svg width="104" height="104" viewBox="0 0 32 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M11.6667 21.6667V8.33333C11.6667 6.5 13.15 5 15 5H30V3.33333C30 1.5 28.5 0 26.6667 0H3.33333C1.48333 0 0 1.5 0 3.33333V26.6667C0 28.5 1.48333 30 3.33333 30H26.6667C28.5 30 30 28.5 30 26.6667V25H15C13.15 25 11.6667 23.5 11.6667 21.6667ZM16.6667 8.33333C15.75 8.33333 15 9.08333 15 10V20C15 20.9167 15.75 21.6667 16.6667 21.6667H31.6667V8.33333H16.6667ZM21.6667 17.5C20.2833 17.5 19.1667 16.3833 19.1667 15C19.1667 13.6167 20.2833 12.5 21.6667 12.5C23.05 12.5 24.1667 13.6167 24.1667 15C24.1667 16.3833 23.05 17.5 21.6667 17.5Z" fill="#566FB8"/>
                                                                </svg>
                                                            </v-list-item-avatar>
                                                        </v-col>             
                                                        <v-col cols=4 class="pa-0 text-right">
                                                            <div
                                                                tile
                                                                size="32"
                                                                v-if="paymentMode == 'online'"
                                                                color="grey lighten-4"
                                                            >
                                                                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <circle cx="16" cy="16" r="16" fill="#6FBC96"/>
                                                                <path d="M6.6665 16.6667L10.7136 21.292C11.0617 21.6899 11.6593 21.748 12.0776 21.4248L25.9998 10.6667" stroke="white" stroke-width="2"/>
                                                                </svg>
                                                            </div>
                                                        </v-col>                     
                                                    </v-row>    
                                                </v-col>                                                                                        
                                            
                                                <v-col cols=12 class="pa-0">
                                                    <v-list-item-content style="display:block;margin:auto;" class="pb-0">       
                                                        <v-list-item-title class="pa-0 ma-0">
                                                            <h3 class="mb-0">Pay Online</h3>
                                                        </v-list-item-title>
                                                        <v-list-item-subtitle class="mt-1 subtitle-2">Pay online via Debit card or UPI now</v-list-item-subtitle>
                                                    </v-list-item-content>
                                                </v-col>                                                                                            
                                            </v-row>
                                        </v-list-item>
                                    
                                    </v-card>
                                </v-col>     
                                <v-col cols=12 md="5" v-if="this.bookingType === 'clinic'">                                    
                                    <v-card                                        
                                        max-width="512"    
                                        outlined
                                        @click="paymentMode = 'clinic'"
                                    >
                                        <v-list-item three-line style="min-height:88px !important;" class="pa-5">
                                            <v-row  class="ma-0 pa-0">
                                                
                                                <v-col cols=12 class="pa-0 ">
                                                    <v-row class="ma-0 pa-0">
                                                        <v-col cols=8 class="pa-0">
                                                            <v-list-item-avatar
                                                                tile
                                                                size="104"
                                                                style="margin:auto; padding:16px"
                                                                color="grey lighten-4"
                                                            >
                                                                <svg width="56" height="56" viewBox="0 0 32 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M4.33346 4.00008H27.6668C28.5835 4.00008 29.3335 3.25008 29.3335 2.33341C29.3335 1.41675 28.5835 0.666748 27.6668 0.666748H4.33346C3.41679 0.666748 2.66679 1.41675 2.66679 2.33341C2.66679 3.25008 3.41679 4.00008 4.33346 4.00008ZM29.6001 7.00008C29.4501 6.23341 28.7668 5.66675 27.9668 5.66675H4.03346C3.23346 5.66675 2.55012 6.23341 2.40012 7.00008L0.733456 15.3334C0.533456 16.3667 1.31679 17.3334 2.36679 17.3334H2.66679V25.6667C2.66679 26.5834 3.41679 27.3334 4.33346 27.3334H17.6668C18.5835 27.3334 19.3335 26.5834 19.3335 25.6667V17.3334H26.0001V25.6667C26.0001 26.5834 26.7501 27.3334 27.6668 27.3334C28.5835 27.3334 29.3335 26.5834 29.3335 25.6667V17.3334H29.6335C30.6835 17.3334 31.4668 16.3667 31.2668 15.3334L29.6001 7.00008V7.00008ZM16.0001 24.0001H6.00012V17.3334H16.0001V24.0001Z" fill="#566FB8"/>
                                                                </svg>
                                                            </v-list-item-avatar>
                                                        </v-col>             
                                                        <v-col cols=4 class="pa-0 text-right">
                                                            <div
                                                                tile
                                                                size="32"
                                                                v-if="paymentMode == 'clinic'"
                                                                color="grey lighten-4"
                                                            >
                                                                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <circle cx="16" cy="16" r="16" fill="#6FBC96"/>
                                                                <path d="M6.6665 16.6667L10.7136 21.292C11.0617 21.6899 11.6593 21.748 12.0776 21.4248L25.9998 10.6667" stroke="white" stroke-width="2"/>
                                                                </svg>
                                                            </div>
                                                        </v-col>                     
                                                    </v-row>    
                                                </v-col>                                                                                        
                                            
                                                <v-col cols=12 class="pa-0">
                                                    <v-list-item-content style="display:block;margin:auto;" class="pb-0">       
                                                        <v-list-item-title class="pa-0 ma-0">
                                                            <h3 class="mb-0">Pay at Clinic Visit</h3>
                                                        </v-list-item-title>
                                                        <v-list-item-subtitle class="mt-1 subtitle-2">Pay when you visit the Doctor at the clinic</v-list-item-subtitle>
                                                    </v-list-item-content>
                                                </v-col>                                                                                            
                                            </v-row>
                                        </v-list-item>
                                    
                                    </v-card>
                                </v-col>     
                                       
                            </v-row>
                        </v-col>
                        <v-col cols="12" class="mt-12 pt-0">
                            <v-btn text class="primary white--text mr-2" @click="step--">
                                Previous
                            </v-btn>
                            <v-btn text
                                   class="white--text"
                                   :class="{ 'accent' :  Object.keys(selectedSlot).length && paymentMode, 'grey' :  !Object.keys(selectedSlot).length || !paymentMode}"
                                   @click="nextStep()"
                                   :disabled="!Object.keys(selectedSlot).length || !paymentMode"
                                   :loading="isLoading">
                                   Confirm Appointment                                                                      
                            </v-btn>
                            <div v-if="userInfo && !paymentMode" class="mt-2">
                                        <span class="red--text">Please select a payment mode to continue</span>
                                    </div>
                        </v-col>
                        
                    </v-row>
                </v-col>
                <!--                Done-->
                <v-col cols="12" sm="12" md="8" v-if="1==2">
                    <v-row class="text-center">
                        <v-col cols="12">
                            <v-row>
                                <!--                                <v-col cols="12">-->
                                <!--                                    <h2>Done</h2>-->
                                <!--                                </v-col>-->
                                <v-col cols="12">

                                    <svg width="224" height="182" viewBox="0 0 308 266" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <path d="M258 133C258 202.036 202.036 258 133 258C63.9644 258 8 202.036 8 133C8 63.9644 63.9644 8 133 8C202.036 8 228 55.5 228 55.5"
                                              stroke="#1B222E" stroke-opacity="0.75" stroke-width="15"/>
                                        <path d="M62 130.024L117.116 191L300 45" stroke="#1B222E" stroke-opacity="0.75"
                                              stroke-width="15" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>

                                    <br><br>
                                    <h1>Your Appointment has been scheduled</h1>

                                    <div class=" my-6 grey--text text--darken-1">
                                        Complete your profile and keep track of all your questions, book appointments &
                                        save medical records.
                                    </div>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="12">
                            <v-btn text class="accent white--text mr-4" @click="goToPatientPortalMain('')">
                                Explore Dashboard
                            </v-btn>

                        </v-col>
                    </v-row>
                </v-col>
                <v-col cols="12" sm="12"  md="4" class="hidden-sm-and-down mt-10">
                    
                    <doctor-card                        
                        :clinic="clinic"
                        :doctor="doctor" 
                        :appointment_type="bookingType" 
                        :fee="consultationInfo.fee"
                        :show_map_btn="false"
                        :start_time="selectedSlot.start_time ? dateutils.toUtcString(selectedSlot.start_time): ''"
                        :end_time="selectedSlot.end_time ? dateutils.toUtcString(selectedSlot.end_time) : ''"
                        :date="bookingDate"
                    >
                    </doctor-card>
                    
                </v-col>
            </v-row>

        </v-container>

        <!--        Login Modal-->
        <v-dialog v-model="loginDialog" max-width="900" persistent>
            <v-card>
                <patient-login @loginResult="setPatientValues"></patient-login>
                <v-card-actions class="pt-0">
                    <v-spacer></v-spacer>
                    <v-btn text @click.prevent="loginDialog = false">
                        Close
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!--        Mobile HTML Below -->
        <v-btn
                fixed
                fab
                color="accent"
                left
                bottom
                class="hidden-md-and-up ml-1"
                @click="doctorDialog = true"
        >
            <v-icon>mdi-doctor</v-icon>
        </v-btn>

        <!--        Doctor Modal-->
        <v-dialog v-model="doctorDialog" max-width="900">
            <v-card flat class=" pt-10">
                
                <v-card-text class="pt-4">
                    <doctor-card                        
                        :clinic="clinic"
                        :doctor="doctor" 
                        :appointment_type="bookingType" 
                        :fee="consultationInfo.fee"
                        :show_map_btn="false"
                        :start_time="selectedSlot.start_time"
                        :end_time="selectedSlot.end_time"
                    >
                    </doctor-card>
                </v-card-text>
                <v-card-actions class="pt-0">
                    <v-spacer></v-spacer>
                    <v-btn text @click.prevent="doctorDialog = false">
                        Close
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import PatientLogin from "../components/Login/PatientLogin";
    import DatePicker from '../components/DatePicker'
    import DoctorCard from "../components/Doctor/DoctorCard";

    export default {
        name: "BookAppointment",
        watch: {
            bookingDate(bookingDate) {
                this.getSchedule(bookingDate)
            },
            symptomSearch(){
                this.getSymptoms()
            },
			selectedSymptoms()
			{
				
				this.symptomSearch = ""
			}
        },
        components: {
            PatientLogin,
            DatePicker,
            DoctorCard
        },
        computed: {
            ...mapGetters([
                'accessToken',
                'userInfo'
            ]),
        },
        mounted() {
            
            this.bookingDates.firstDate = this.moment();
            if(this.$route.query.type === 'online')
                this.paymentMode = 'online'
            this.makeBookingDates('now');
            this.bookingDate =  this.moment("2014-02-27T10:00:00").format('DD-MM-YYYY');
            this.axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('accessToken')
            this.getDoctorDetails();
            this.getConsultationInfo();
            this.setPatientValues();
            this.getSchedule(this.moment().format('YYYY-MM-DD'));
            this.bookingType = this.$route.query.type;
            
            if(this.bookingType === 'clinic')
                this.maxStep = 2
            else
                this.maxStep = 1
            if(this.bookingType === 'clinic')
                this.getClinic()
            
        },
        data() {
            return {
                apiUrl:process.env.VUE_APP_API_URL,
                doctorDialog: false,
                loginDialog: false,
                isLoading: false,
                gettingSlots: false,
                bookingMonth: 'June',
                bookingDate: null,
                selectedSlot: {},
                schedulesList: [],
                scheduleRequest: {},
                doctor: {},
                clinic: {},
                appointmentCreated: false,
                createdAppontment: {},
                bookingType: 'clinic',
                bookingDates: {
                    year: [2020],
                    months: ['June', 'July'],
                    dates: [],
                    firstDate: null,
                    lastDate: null,
                },
                patient: {
                    name: null,
                    gender: null,
                    dob: null,
                    is_primary_profile: 1,
                    mobile: null
                },
                appointment: {
                    type: 'clinic',
                    no_of_slots_booked: 1,
                    start_time: null,
                    end_time: null,
                    is_paid: 1,
                    doctor_id: null,
                    clinic_id: this.$route.query.clinic_id,
                },
                items: ['Dentist', 'Pediatrician'],
                genderList: ['Male', 'Female', 'Others'],
                step: 0,
                maxStep:null,
                stepDetails: [
                    {
                        title: "Select Time Slot",
                        description: "Get on-demand consultations as and when you need them."
                    },
                    {
                        title: "Additional Info",
                        description: "Explain your symptoms & problem for better diagnosis."
                    },
                    {
                        title: "Payment",
                        description: "How would you like to pay for this appointment?"
                    }
                ],
                symptomsList:[],
                selectedSymptoms:[],
                symptomSearch:"",
                symptomLoading:false,
                paymentMode:null,
                problem:"",
                consultationInfo:null
            }
        },
        methods: {
   
            nextStep() {
                if (this.step === 0 && !this.userInfo) {
                    this.loginDialog = true;
                    return;
                }
                else if(this.step === this.maxStep){
                    if(this.appointmentCreated){
                        if(this.paymentMode == 'online')
                            this.payNow()
                    }
                    else{
                        this.createAppointment()
                    }
                    
                }
                else
                    this.step++;

                window.scrollTo(0,0);
            },
            setPatientValues() {
                if (this.userInfo) {
                    this.patient.name = this.userInfo.name;
                    this.patient.gender = this.userInfo.gender;
                    this.patient.dob = this.userInfo.dob;
                    this.patient.mobile = this.userInfo.mobile;
                    this.patient.email = this.userInfo.email;
                }
                if (this.loginDialog) {
                    this.nextStep();
                }
                this.loginDialog = false;
            },
            getDoctorDetails() {
                this.axios
                    .get(`${process.env.VUE_APP_API_URL}/api/doctors/` + this.$route.query.id)
                    .then((response) => {
                        this.doctor = response.data.data;
                    }).catch((error) => {
                    console.log(error);
                });
            },
            getClinic() {
                this.axios
                    .get(`${process.env.VUE_APP_API_URL}/api/clinics/` + this.$route.query.clinic_id)
                    .then((response) => {
                        this.clinic = response.data.data;
                    }).catch((error) => {
                    console.log(error);
                });
            },
            getConsultationInfo() {
                this.axios
                    .get(`${process.env.VUE_APP_API_URL}/api/doctors/` + this.$route.query.id + `/consultation-info`,
                    {
                        params:{
                            clinic_id:this.$route.query.clinic_id
                        }
                    })
                    .then((response) => {
                        this.consultationInfo = response.data.data;
                    }).catch((error) => {
                    console.log(error);
                });
            },
            makeBookingDates(direction) {
                this.bookingDates.dates = [];
                let firstDay = this.moment();
                if (direction === 'next') {
                    firstDay = this.bookingDates.lastDate
                } else if (direction === 'prev') {
                    firstDay = this.bookingDates.firstDate.add(-6, 'days')
                }

                let lastDay = this.moment(firstDay).add(7, 'days');
                while (firstDay < lastDay) {
                    this.bookingDates.dates.push(firstDay.format('YYYY-MM-DD'));
                    var newDate = firstDay.add(1, 'days');
                    firstDay = newDate;
                }
                this.bookingDate = this.bookingDates.dates[0];
                this.bookingDates.firstDate = this.moment(this.bookingDates.dates[0]);
                this.bookingDates.lastDate = this.moment(this.bookingDates.dates[6]);

            },
            getSchedule(day) {
                
                this.gettingSlots = true;
                let scheduleRequest = {
                    start_date: day,
                    end_date: day,
                    doctor_id: this.$route.query.id,
                    clinic_id: this.appointment.clinic_id,
                    timezone:this.$store.getters.timezone
                }

                if (day === undefined) {
                    return;
                }

                if (this.$route.query.type === 'online') {
                    scheduleRequest.is_online = 1;
                }
                else
                    scheduleRequest.is_online = 0;

                this.axios
                    .get(`${process.env.VUE_APP_API_URL}/api/appointments/availability`, {
                        params: scheduleRequest
                    })
                    .then((response) => {
                        this.schedulesList = response.data.data;
                        this.gettingSlots = false;
                    }).catch((error) => {
                    console.log(error);
                    this.gettingSlots = false;
                });
            },
            selectSlot(slot) {

                this.schedulesList.map(function (slots) {
                    slots.slots.map(function (item) {
                        item.is_selected = false;
                    })
                });

                slot.is_selected = true;
                this.selectedSlot = slot;                                
            },
            createAppointment() {
                this.isLoading = true;
                this.appointment.start_time = this.selectedSlot.start_time;
                this.appointment.end_time = this.selectedSlot.end_time;
                this.appointment.doctor_id = this.$route.query.id;
                this.appointment.type = this.$route.query.type;                
                this.appointment.payment_mode = this.paymentMode
                this.appointment.problem = this.problem

                var appointment_request = this.appointment;
                
                //var start_format = this.moment(this.selectedSlot.start_time, iso_format).utc()
                var start_format = this.dateutils.toUtcString(this.selectedSlot.start_time)
                var end_format = this.dateutils.toUtcString(this.selectedSlot.end_time)

                appointment_request.start_time = start_format
                appointment_request.end_time = end_format
                console.log(appointment_request)

                var symptomIds =[]
                this.selectedSymptoms.forEach(function(item) {
                    symptomIds.push(item.id)
                });
                this.appointment.symptoms = symptomIds
                                                
                this.axios.post(`${process.env.VUE_APP_API_URL}/api/appointments/patient`, appointment_request)
                    .then((response) => {
                        if(response.data.status == 1){
                            this.createdAppontment = response.data.data;
                            this.appointmentCreated = true
                            
                            this.isLoading = false;
                            if(this.paymentMode == 'online'){
                                this.payNow()
                            }
                            else{
                                this.$router.replace({name: 'appointmentCreated', params: {id: this.createdAppontment.id}});
                            }
                        }
                        
                    }).catch((error) => {
                        
                    console.log(error);
                    this.isLoading = false;
                });
            },
            getSymptoms() {
                this.symptomLoading = true;
                this.axios
                    .get(`${process.env.VUE_APP_API_URL}/api/symptoms/search`,{
                        params:{
                            query:this.symptomSearch
                        }
                    })
                    .then((response) => {
                    var list  = response.data.data;                     
                    var elementsToBePushed = [];           
                    //console.log(this.selectedSymptoms)         
                    for(var i=0; i < this.selectedSymptoms.length; i++){
                            var selectedItem = JSON.parse(JSON.stringify(this.selectedSymptoms[i]))                            
                            console.log(selectedItem.id)
                            var itemFound = false
                            for(var j=0; j < list.length; j++){
                                var newItem = list[j];
                                if(newItem.id.localeCompare(selectedItem.id) == 0){
                                    console.log("MATCH FOUND")
                                    itemFound = true                                    
                                    break;
                                }                                    
                            }                            
                            if(!itemFound)
                                elementsToBePushed.push(selectedItem)                                                                 
                            
                    }
                    
                    list = list.concat(elementsToBePushed);       
                      
                    this.symptomsList = list
                    
                    }).catch((error) => {
                        console.log(error); 
                    }).finally(() => {
                        this.symptomLoading = false;
                    })
            },
            removeSymptoms (item) {
                var index = null
                for(var i=0; i<this.selectedSymptoms.length;i++){
                    if(this.selectedSymptoms[i].id.localeCompare(item.id)==0){
                        index = i
                        break;                        
                    }
                }
                
                if (index >= 0) this.selectedSymptoms.splice(index, 1)
            },
            payNow() {
                let data = {
                    appointment_id: this.createdAppontment.id,
                    patient_id: this.createdAppontment.patient_id                    
                }
                                
                let payload = btoa(JSON.stringify(data));

                let url = process.env.VUE_APP_API_URL + '/payments/initiate?payload=' + payload;
                window.location.href = url;
            }
        },
    }
</script>

<style scoped>
    .time-slots .v-chip {
        background-color: #fafafa;
        min-width:96px;
        text-align: center;
    }

    
</style>
